






















import { Component, Vue } from "vue-property-decorator";
@Component
export default class BookingTypeInputComponent extends Vue {
  public COVID_CONTACT: any = "yes";
  public COVID_SYMPTOMS: any = "yes";

  constructor(){
    super();
    this.COVID_SYMPTOMS = "yes";
    this.COVID_CONTACT = "yes";
  }

  /* eslint-disable */
  public onChange($event: any): void {
    this.$emit("onChange", {
      contact: this.COVID_CONTACT,
      symptoms: this.COVID_SYMPTOMS
    });
  }
}
